var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cornerbar"},[_c('div',{staticClass:"contact-btn",on:{"click":function($event){return _vm.toCooperation('cooperation')}}},[_c('span'),_vm._v("合作咨询")]),(_vm.btnFlag)?_c('div',{staticClass:"backTop-btn",on:{"click":_vm.backTop}},[_c('i',{staticClass:"el-icon-arrow-up"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }